/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import t from "../../../Common/utils/translation/translator";

const CorrespondingCountry = (props) => {
  const tooltipContent = `${t("msizer.ui.tooltip.corresponding_country_prefix")} ${props.country}. ${t(
    "msizer.ui.tooltip.corresponding_country_suffix"
  )}`;
  return (
    <div className="flex items-center space-x-2">
      <img
        className="h-5"
        src={`${process.env.REACT_APP_STATIC_FILES_URL || process.env.PUBLIC_URL}/flags/${props.country}.svg`}
        alt={props.country}
      />
      <span className=" text-xs text-gray-500">{props.country}</span>
      <MsxIcons data-tip={tooltipContent} name="info" size="nano" className="text-gray-400" />
      <ReactTooltip
        type="light"
        effect="solid"
        backgroundColor="#FFFFFF"
        textColor="rgb(31 41 55)"
        className="hover:visible shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
        html
      />
    </div>
  );
};

CorrespondingCountry.propTypes = {
  country: PropTypes.string
};

CorrespondingCountry.defaultProps = {
  country: ""
};

export default CorrespondingCountry;
